import CurrencyIcon from '../icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';
import { useLocale } from 'next-intl';

const PricingCard = ({ prices, fromPdp, showOfferLabel }) => {
  const locale = useLocale();
  if (fromPdp)
    return (
      <div className='mb-3 flex items-baseline gap-2'>
        <span className='flex items-center gap-1 text-base font-bold text-gray-900'>
          <CurrencyIcon className='size-4 max-sm:size-3.5' />
          {handlePriceByComma(!showOfferLabel ? prices?.originalPrice : prices?.specialPrice || prices?.originalPrice)}{' '}
        </span>
        {prices?.specialPrice && (
          <span className='flex items-center gap-1 text-xs text-gray-500 line-through'>
            <CurrencyIcon className='size-3' />
            {handlePriceByComma(prices?.originalPrice)}{' '}
          </span>
        )}
      </div>
    );
  return (
    <div
      className={`flex items-center gap-2`}
      dir={`${locale == 'en' ? 'rtl' : 'ltr'}`}
    >
      <span className='flex w-full items-center justify-end gap-1 font-bold text-[#B84B34] max-md:text-[15px] max-sm:text-base md:text-base lg:text-lg'>
        <CurrencyIcon className='size-4 max-sm:size-3.5' />
        {handlePriceByComma(!showOfferLabel ? prices?.originalPrice : prices?.specialPrice || prices?.originalPrice)}{' '}
      </span>

      {showOfferLabel && prices?.specialPrice ? (
        <span
          className={`flex items-center gap-1 text-[14px] text-[#666666] line-through max-sm:text-base`}
        >
          <CurrencyIcon className='size-3' />
          {handlePriceByComma(prices?.originalPrice)}{' '}
        </span>
      ) : null}
    </div>
  );
};

export default PricingCard;
